import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import chat from "../../Assets/Projects/chat.png";
import circulus from "../../Assets/Projects/circulus.png";
import cashregister from "../../Assets/Projects/cash-register.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={circulus}
              isBlog={false}
              title="Circulus Social Network"
              description="Circulos is a social networking app that allows users to create profiles, explore others' profiles, follow them, and share posts. It fosters a connected community where users can engage and stay updated with each other’s activities."
              ghLink="https://github.com/judacru/api-circulus"
              demoLink="https://circulus.judacru.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cashregister}
              isBlog={false}
              title="Cash Register"
              description="Cash Register is a user-friendly POS application that allows users to register products and track sales. It helps businesses efficiently manage inventory and record transactions, simplifying daily operations."
              ghLink="https://github.com/judacru/react-cash-register"
              demoLink="https://cash-register-jc.web.app/sales"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chat}
              isBlog={false}
              title="Chat Real Time"
              description="Real-time Chat is an instant messaging app powered by WebSockets, enabling seamless communication between users. It allows users to connect, chat, and interact in real-time, providing a smooth and engaging messaging experience."
              ghLink="https://github.com/judacru/react-real-time-chat"
              demoLink="https://real-time-chat-jc.web.app/"              
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
